module.exports = __webpack_public_path__ + "img/default_profile.043b126e.png";